// const for action types here
/* eslint-disable import/prefer-default-export */
export const GET_PRODUCT_DETAILS_FULFILLED = 'GET_PRODUCT_DETAILS_FULFILLED';
export const GET_PRODUCT_DETAILS_FAILED = 'GET_PRODUCT_DETAILS_FAILED';
export const GET_PRODUCT_DETAILS_PENDING = 'GET_PRODUCT_DETAILS_PENDING';

export const GET_SAMPLE_DETAILS_PENDING = 'GET_SAMPLE_DETAILS_PENDING';
export const GET_SAMPLE_DETAILS_FULFILLED = 'GET_SAMPLE_DETAILS_FULFILLED';
export const GET_SAMPLE_DETAILS_FAILED = 'GET_SAMPLE_DETAILS_FAILED';

export const UPDATE_PRODUCT_LINE_CONFIGURATION = 'UPDATE_PRODUCT_LINE_CONFIGURATION';

export const INVALID_SHAPE = 'INVALID_SHAPE';

export const SAVE_SHAPES_STARTED = 'SAVE_SHAPES_STARTED';
export const SAVE_SHAPES_FINISHED = 'SAVE_SHAPES_FINISHED';
export const SAVE_SHAPES_FAILED = 'SAVE_SHAPES_FAILED';

export const LOAD_SHAPES_STARTED = 'LOAD_SHAPES_STARTED';
export const LOAD_SHAPES_FINISHED = 'LOAD_SHAPES_FINISHED';
export const LOAD_SHAPES_FAILED = 'LOAD_SHAPES_FAILED';

export const LOAD_DEFAULT_SHAPE_DIMENSIONS = 'LOAD_DEFAULT_SHAPE_DIMENSIONS';
export const LOAD_SHAPE_INFO_FROM_CONFIGURATION = 'LOAD_SHAPE_INFO_FROM_CONFIGURATION';
export const PERSISTED_SHAPE_INFO = 'PERSISTED_SHAPE_INFO';
export const LOADED_PERSISTED_SHAPE = 'LOADED_PERSISTED_SHAPE';

export const UPDATE_TOTAL_EXTERIOR_CORNERS = 'UPDATE_TOTAL_EXTERIOR_CORNERS';
export const UPDATE_TOTAL_INTERIOR_CORNERS = 'UPDATE_TOTAL_INTERIOR_CORNERS';

export const SET_SURFACE = 'SET_SURFACE';
export const SET_CURRENT_SURFACE = 'SET_CURRENT_SURFACE';
export const SET_CURRENT_SKU = 'SET_CURRENT_SKU';
export const SET_COUNTERTOP_SURFACES = 'SET_COUNTERTOP_SURFACES';
export const SET_SELECTED_COLOR_SORT = 'SET_SELECTED_COLOR_SORT';
export const SET_SELECTED_COLOR = 'SET_SELECTED_COLOR';
export const SET_SELECTED_COLOR_FILTERS = 'SET_SELECTED_COLOR_FILTERS';
export const UPDATE_COLOR_SWATCHES = 'UPDATE_COLOR_SWATCHES';

export const GET_COUNTERTOP_SURFACES_PENDING = 'GET_COUNTERTOP_SURFACES_PENDING';
export const GET_COUNTERTOP_SURFACES_FULFILLED = 'GET_COUNTERTOP_SURFACES_FULFILLED';
export const GET_COUNTERTOP_SURFACES_FAILED = 'GET_COUNTERTOP_SURFACES_FAILED';

export const SEARCH_FULFILLED = 'SEARCH_FULFILLED';
export const SEARCH_FAILED = 'SEARCH_FAILED';
export const SEARCH_PENDING = 'SEARCH_PENDING';

export const GET_ZIPCODE_FULFILLED = 'GET_ZIPCODE_FULFILLED';
export const GET_ZIPCODE_FAILED = 'GET_ZIPCODE_FAILED';
export const GET_ZIPCODE_PENDING = 'GET_ZIPCODE_PENDING';
export const CLEAR_ZIPCODE = 'CLEAR_ZIPCODE';
export const CHANGE_ZIPCODE = 'CHANGE_ZIPCODE';
export const SEARCH_BY_ZIPCODE_FULFILLED = 'SEARCH_BY_ZIPCODE_FULFILLED';
export const SEARCH_BY_ZIPCODE_FAILED = 'SEARCH_BY_ZIPCODE_FAILED';
export const SEARCH_BY_ZIPCODE_PENDING = 'SEARCH_BY_ZIPCODE_PENDING';
export const INVALIDATE_ZIPCODE = 'INVALIDATE_ZIPCODE';

export const SET_CURRENT_STORE = 'SET_CURRENT_STORE';
export const SET_CURRENT_STORE_ID_AND_ZIPCODE = 'SET_CURRENT_STORE_ID_AND_ZIPCODE';

export const SAVE_CONFIGURATION = 'SAVE_CONFIGURATION';
export const TOGGLE_MOBILE_SIDE_DRAWER = 'TOGGLE_MOBILE_SIDE_DRAWER';
export const CREATE_DESIGN = 'CREATE_DESIGN';
export const CREATE_DESIGN_FAILED = 'CREATE_DESIGN_FAILED';
export const UPDATE_ITEM_PRODUCT = 'UPDATE_ITEM_PRODUCT';
export const UPDATE_ITEM_PRODUCT_FAILED = 'UPDATE_ITEM_PRODUCT_FAILED';
export const GET_DESIGN_BY_ITEM = 'GET_DESIGN_BY_ITEM';
export const GET_DESIGN_BY_ITEM_FAILED = 'GET_DESIGN_BY_ITEM_FAILED';
export const ENABLE_SAVE = 'ENABLE_SAVE';
export const DISABLE_SAVE = 'DISABLE_SAVE';
export const SAVE_CONFIG_START = 'SAVE_CONFIG_START';
export const SAVE_CONFIG_SUCCESS = 'SAVE_CONFIG_SUCCESS';
export const SAVE_CONFIG_FAILED = 'SAVE_CONFIG_FAILED';
export const SAVE_ONLINE_DESIGN_SUCCESS = 'SAVE_ONLINE_DESIGN_SUCCESS';
export const SAVE_ONLINE_DESIGN_FAILED = 'SAVE_ONLINE_DESIGN_FAILED';
export const SEND_DESIGN_EMAIL_SUCCESS = 'SEND_DESIGN_EMAIL_SUCCESS';
export const SEND_DESIGN_EMAIL_FAILED = 'SEND_DESIGN_EMAIL_FAILED';

export const SET_PRODUCT_AVAILABILITY = 'SET_PRODUCT_AVAILABILITY';
export const SET_CONFIG = 'SET_CONFIG';
export const SET_CONFIG_ENVIRONMENT = 'SET_CONFIG_ENVIRONMENT';

export const TOGGLE_PLCC_MODAL = 'TOGGLE_PLCC_MODAL';

export const CHOICE_CHANGED_SUCCESS = 'CHOICE_CHANGED_SUCCESS';
export const UPDATE_INITIAL_LOAD = 'UPDATE_INITIAL_LOAD';
export const SET_LAMINATE_POST_FORM_FEATURE_GATE = 'SET_LAMINATE_POST_FORM_FEATURE_GATE';
export const VALIDATE_SELECTED_CHOICES = 'VALIDATE_SELECTED_CHOICES';

export const SHOW_MAX_SINK_QUANTITY_WARNING = 'SHOW_MAX_SINK_QUANTITY_WARNING';
export const HIDE_MAX_SINK_QUANTITY_WARNING = 'HIDE_MAX_SINK_QUANTITY_WARNING';

export const IMAGE_ASSIST_PENDING = 'IMAGE_ASSIST_PENDING';
export const IMAGE_ASSIST_FULFILLED = 'IMAGE_ASSIST_FULFILLED';
export const IMAGE_ASSIST_FAILED = 'IMAGE_ASSIST_FAILED';
export const IMAGE_ASSIST_CLEAR = 'IMAGE_ASSIST_CLEAR';
export const IMAGE_ASSIST_APPLIED = 'IMAGE_ASSIST_APPLIED';

export const SHAPE_TELEMETRY_APPLIED = 'SHAPE_TELEMETRY_APPLIED';
export const SHAPE_TELEMETRY_PRUNED = 'SHAPE_TELEMETRY_PRUNED';
